// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__etNgW","select":"Header_select__wlwve","clinic":"Header_clinic__2iyI3"};